import { render, staticRenderFns } from "./clickerheader.vue?vue&type=template&id=3b7ba080"
import script from "./clickerheader.vue?vue&type=script&lang=js"
export * from "./clickerheader.vue?vue&type=script&lang=js"
import style0 from "./clickerheader.vue?vue&type=style&index=0&id=3b7ba080&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports